import "./orderConfiguration.js";
import "./orderConfigurationDetailsPage.js";


// WEBPACK FOOTER //
// ./src/pages/orderConfiguration/index.js